import { IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";

//BFL-Handler hanterar
export const bflHelper = () => {
  const cleanFunktionsKontroller = (arr: IKontrollResultRow[]): IKontrollResultRow[] => {
    if (arr && arr.length) {
      for (var i = 0; i < arr.length; i++) {
        var entry = arr[i];
        if (!entry.kWhs) {
          entry.kWhs = undefined;
          entry.energiSlag = "";
        }
        // if (entry.hasOwnProperty("inverteraTecken")) {
        //   (entry as IKontrollResultRowDriftoptimering)["inverteraTecken"] = (entry as IKontrollResultRowDriftoptimering)["inverteraTecken"] ? true : false;
        //   (entry as IKontrollResultRowDriftoptimering).Åtgärdad = true;
        // }
      }
    }

    return arr;
  };

  const cleanDriftoptimeringar = (arr: IKontrollResultRowDriftoptimering[]): IKontrollResultRowDriftoptimering[] => {
    if (arr && arr.length) {
      for (var i = 0; i < arr.length; i++) {
        var entry = arr[i];
        if (!entry.kWhs) {
          entry.kWhs = undefined;
          entry.energiSlag = "";
        }

        entry.inverteraTecken = entry.inverteraTecken ? true : false;
        entry.Åtgärdad = true;
      }
    }

    return arr;
  };

  //Public stuff
  var mod = {
    cleanFunktionsKontroller,
    cleanDriftoptimeringar,
  };

  return mod;
};

const dflt = { bflHelper };

export default dflt;
